import {
  RESET_ROLES,
  RESET_ROLE,
  RESET_ERROR,
  GET_ROLES,
  SET_ROLES,
  API_ERROR,
  CREATE_ROLE,
  CREATE_ROLE_SUCCESS,
  GET_ROLE,
  SET_ROLE,
  EDIT_ROLE,
  EDIT_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorRole: false,
  loadingRole: false,
  dataRole: null,
  successRole: false,
};

const Role = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ROLES:
      state = {
        ...state,
        errorRole: false,
        loadingRole: false,
        loadingRoleDelete: false,
        successRole: false,
        dataRole: null,
        dataRoleDelete: null,
      };
      break;
    case RESET_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRole: false,
        successRole: false,
        dataRoleGetSet: null,
        dataRoleEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorRole: false,
        loadingRole: false,
        loadingRoleEditCreate: false,
        loadingRoleActivate: false,
        successRole: false,
      };
      break;
    case GET_ROLES:
      state = {
        ...state,
        errorRole: false,
        loadingRole: true,
        dataRole: null,
      };
      break;
    case SET_ROLES:
      state = {
        ...state,
        errorRole: false,
        loadingRole: false,
        dataRole: action.payload,
      };
      break;
    case CREATE_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRoleEditCreate: true,
        dataRoleEditCreate: action.payload,
        successRole: false,
      };
      break;
    case CREATE_ROLE_SUCCESS:
      state = {
        ...state,
        errorRole: false,
        loadingRoleEditCreate: false,
        dataRoleEditCreate: action.payload,
        successRole: true,
      };
      break;
    case GET_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRole: true,
        dataRoleGetSet: null,
      };
      break;
    case SET_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRole: false,
        dataRoleGetSet: action.payload,
      };
      break;
    case EDIT_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRoleEditCreate: true,
        dataRoleEditCreate: action.payload,
        successRole: false,
      };
      break;
    case EDIT_ROLE_SUCCESS:
      state = {
        ...state,
        errorRole: false,
        loadingRoleEditCreate: false,
        dataRoleEditCreate: action.payload,
        successRole: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorRole: action.payload,
        loadingRole: false,
        loadingRoleDelete: false,
        successRole: false,
      };
      break;
    case DELETE_ROLE:
      state = {
        ...state,
        errorRole: false,
        loadingRoleDelete: true,
        dataRoleDelete: action.payload,
        successRole: false,
      };
      break;
    case DELETE_ROLE_SUCCESS:
      state = {
        ...state,
        errorRole: false,
        loadingRoleDelete: false,
        dataRoleDelete: action.payload,
        successRole: true,
      };
      break;
    default:
      // state = { ...state, errorRole: false, loadingRole: false };
      break;
  }
  return state;
};

export default Role;
